<section class="form-debug" aria-label="Diagnostyka formularza">
  <div class="form-debug__toolbar">
    <button type="button" class="form-debug__button" (click)="inspect()">
      🔎 Sprawdź formularz
    </button>
    <span *ngIf="checked && form" class="form-debug__status"
          [class.form-debug__status--bad]="!formValid">
      {{ formStatus }}
    </span>
  </div>

  <div *ngIf="checked" class="form-debug__results">
    <p *ngIf="!form">Brak przekazanego formularza. Użyj atrybutu [form] z registrationForm.</p>

    <ng-container *ngIf="form">
      <p class="form-debug__summary">
        {{ title }} — status: <strong>{{ formStatus }}</strong>;
        problemy: <strong>{{ blockingCount }}</strong>
      </p>

      <p class="form-debug__warning"
         *ngIf="externalValidAtCheck !== null && externalValidAtCheck !== formValid">
        Uwaga: flaga przekazana przez [externalValid] różni się od form.valid.
        Sprawdź logikę blokowania przycisku Zapisz.
      </p>

      <p *ngIf="rows.length === 0">Nie znaleziono błędnych ani oczekujących kontrolek.</p>

      <div *ngIf="rows.length > 0" class="form-debug__table-wrapper">
        <table class="form-debug__table">
          <thead>
            <tr>
              <th scope="col">Kontrolka</th>
              <th scope="col">Status</th>
              <th scope="col">Błędy</th>
              <th scope="col" *ngIf="showValues">Wartość</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows" [class.form-debug__disabled-row]="!row.blocking">
              <td><code>{{ row.path }}</code></td>
              <td>{{ row.status }}</td>
              <td><code>{{ row.errorsText }}</code></td>
              <td *ngIf="showValues"><code>{{ row.valueText }}</code></td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="form-debug__hint">
        DISABLED nie blokuje zapisu. PENDING oznacza oczekiwanie na zakończenie walidacji.
        Szczegóły znajdziesz też w konsoli.
      </p>
    </ng-container>
  </div>
</section>
